import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Talents from "@/pages/Talents";
import TalentDetail from "@/pages/TalentDetail";
import Booking from "@/pages/Booking";
import Pay from "@/pages/Pay";
import OrderStatus from "@/pages/OrderStatus";
import CheckOrder from "@/pages/CheckOrder";
import ApplyTalent from "@/pages/ApplyTalent";
import Login from "@/pages/Login";
import TalentDashboard from "@/pages/TalentDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import Terms from "@/pages/Terms";

function Protected({ role, children }) {
  const { user } = useAuth();
  if (user === null) return <div className="py-24 text-center text-slate-500" data-testid="auth-loading">Memuat...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) return <Navigate to={user.role === "admin" ? "/admin" : "/talent-dashboard"} replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/talent" element={<Talents />} />
              <Route path="/talent/:id" element={<TalentDetail />} />
              <Route path="/booking/:talentId" element={<Booking />} />
              <Route path="/pay/:code" element={<Pay />} />
              <Route path="/order/:code" element={<OrderStatus />} />
              <Route path="/cek-order" element={<CheckOrder />} />
              <Route path="/daftar-talent" element={<ApplyTalent />} />
              <Route path="/login" element={<Login />} />
              <Route path="/syarat" element={<Terms />} />
              <Route path="/talent-dashboard" element={<Protected role="talent"><TalentDashboard /></Protected>} />
              <Route path="/admin" element={<Protected role="admin"><AdminDashboard /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        <Toaster position="bottom-center" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
